import React from "react";
import { allFilters, IFilterTagProps } from "./definitions";
import { useAppDispatch } from "../../app/store/hooks";
import { useFilterSheets } from "./hooks";
import Tag from "@amzn/meridian/tag";

export const FilterTag: React.FC<IFilterTagProps> = ({ filterKey, filterValue }) => {
    const dispatch = useAppDispatch();
    const { handleFilterMapUpdate } = useFilterSheets();

    return (
        <Tag
            key={`${filterKey}-${filterValue}`}
            onClose={() =>
                dispatch(
                    handleFilterMapUpdate({
                        type: "REMOVE",
                        filterKey: filterKey,
                    })
                )
            }
        >
            {`${allFilters[filterKey]?.label ?? filterKey}: ${filterValue}`}
        </Tag>
    );
};
